/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import Keycloak from 'keycloak-js';

const _keycloak = new Keycloak('/keycloak.json');

const initKeycloak = (onAuthenticatedCb) => {
  _keycloak.onTokenExpired = () => {
    console.log('Token expired');
    _keycloak
      .updateToken(300)
      .then((refreshed) => {
        console.log(`Token refreshed ${refreshed ? 'successfully' : 'failed'}`);
      })
      .catch(() => {
        console.log('Failed to refresh token');
        _keycloak.login();
      });
  };
  _keycloak
    .init({
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    })
    .then((authenticated) => {
      if (!authenticated) {
        console.log('User not authenticated');
      }
      onAuthenticatedCb();
    })
    .catch(console.error);
};

const doLogin = _keycloak.login;

const doLogout = _keycloak.logout;

const getToken = () => _keycloak.token;

const updateToken = (successCallback) =>
  _keycloak.updateToken(300).then(successCallback).catch(doLogin);

const getUsername = () => _keycloak.tokenParsed.preferred_username;

const hasRole = (roles) =>
  roles.some(
    (role) => _keycloak.hasRealmRole(role) || _keycloak.hasResourceRole(roles),
  );

const isAuthenticated = () => _keycloak.authenticated;

const getUserInfo = _keycloak.loadUserInfo;

const getUserProfile = _keycloak.loadUserProfile;

export default {
  initKeycloak,
  doLogin,
  doLogout,
  getToken,
  updateToken,
  getUsername,
  hasRole,
  isAuthenticated,
  getUserInfo,
  getUserProfile,
};
